import dayjs from 'dayjs';
import Model from '../../models/model';
import consts from '../../consts';

const reportType = {
	BIHistoryReport: consts.isNodeServer ? '6123c4f879f0fa4c6ccab64a' : 149,
	EquipmentUsageReport: consts.isNodeServer ? '6123c4f879f0fa4c6ccab64b' : 150,
	CycleUsageReport: consts.isNodeServer ? '6123c4f879f0fa4c6ccab64c' : 151,
	TaskHistoryReport: consts.isNodeServer ? '6123c4f879f0fa4c6ccab64d' : 152
};

const model = new Model({
	name: 'Report',
	combos: [],
	formGroups: [
		{
			fields: [
				'Report',
				'Format',
				'From',
				'To',
				'IncubatorId',
				'SterilizerId',
				'BIResult',
				'EquipmentId',
				'EquipmentTypeId'
			],
			columnSize: 6
		}
	],
	initialValues: {
		Format: 'PDF',
		From: dayjs().subtract(1, 'month').format(consts.MomentFormat.MonthDateYear),
		To: dayjs(new Date())
	},
	columns: [
		{
			field: 'Report',
			header: 'Report',
			inlineLabelSize: 12,
			lookup: 'ReportType',
			disableClearable: true,
			required: true
		},
		{
			field: 'Format',
			header: 'Format',
			inlineLabelSize: 12,
			disableClearable: true,
			lookup: [
				{ id: 'PDF', label: 'PDF' },
				{ id: 'XLS', label: 'Excel' }
			],
			required: true
		},
		{
			field: 'From',
			header: 'From',
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			inlineLabelSize: 12,
			maxDate: ({ formik }) => (formik.values.To ? dayjs(formik.values.To) : undefined),
			inputWhen: [{ field: 'Report', op: 'in', value: Object.values(reportType) }],
			required: true
		},
		{
			field: 'To',
			header: 'To',
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			inlineLabelSize: 12,
			minDate: ({ formik }) => (formik.values.From ? dayjs(formik.values.From) : undefined),
			inputWhen: [{ field: 'Report', op: 'in', value: Object.values(reportType) }],
			required: true
		},
		{
			field: 'IncubatorId',
			header: 'IncubatorName',
			inlineLabelSize: 12,
			lookup: 'Incubator',
			required: false,
			inputWhen: [['Report', reportType.BIHistoryReport]]
		},
		{
			field: 'SterilizerId',
			header: 'Sterilizer',
			inlineLabelSize: 12,
			lookup: 'Sterilizer',
			required: false,
			inputWhen: [['Report', reportType.BIHistoryReport]]
		},
		{
			field: 'BIResult',
			header: 'BI Result',
			inlineLabelSize: 12,
			lookup: [
				{ id: consts.BIResult.Positive, label: 'Positive' },
				{ id: consts.BIResult.Negative, label: 'Negative' },
				{ id: consts.BIResult.Error, label: 'Error' }
			],
			required: false,
			inputWhen: [['Report', reportType.BIHistoryReport]]
		},
		{
			field: 'EquipmentId',
			header: 'Equipment',
			inlineLabelSize: 12,
			lookup: 'Equipment',
			inputWhen: [
				{
					field: 'Report',
					op: 'in',
					value: [reportType.CycleUsageReport, reportType.EquipmentUsageReport, reportType.TaskHistoryReport]
				}
			],
			required: [{ field: 'Report', op: '$eq', value: () => reportType.EquipmentUsageReport }]
		},
		{
			field: 'EquipmentTypeId',
			header: 'EquipmentType',
			inlineLabelSize: 12,
			lookup: 'EquipmentType',
			required: false,
			inputWhen: [
				{
					field: 'Report',
					op: 'in',
					value: [reportType.CycleUsageReport, reportType.EquipmentUsageReport, reportType.TaskHistoryReport]
				}
			]
		}
	]
});

export default model.createFormDialog();